import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { Volume2, VolumeX } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useMedia } from '..';

export function VolumeControl(volumeControlProps: ComponentProps<'div'>) {
  const { className, ...props } = volumeControlProps;
  const { isMuted, volume, toggleMute } = useMedia();

  return (
    <div className={cn('flex items-center gap-1.5', className)} {...props}>
      <Button size={'sm'} variant={'ghost'} onClick={toggleMute} type={'button'}>
        {isMuted || volume === 0 ? <VolumeX /> : <Volume2 />}
      </Button>
    </div>
  );
}

export function VolumeControlSlider(volumeControlSliderProps: ComponentProps<'input'>) {
  const { className, onChange, ...props } = volumeControlSliderProps;
  const { isMuted, volume, volumeChange } = useMedia();

  return (
    <input
      type="range"
      min={0}
      max={1}
      step={0.1}
      value={isMuted ? 0 : volume}
      onChange={(e) => {
        volumeChange(Number.parseFloat(e.target.value));
        onChange?.(e);
      }}
      className={cn(
        'bg-fill-gray/30 [&::-webkit-slider-thumb]:bg-fill-gray h-1 flex-1 cursor-pointer appearance-none rounded-full [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full',
        className
      )}
      style={{
        background: `linear-gradient(to right, var(--color-fill-gray) 0%, var(--color-fill-gray) ${(isMuted ? 0 : volume) * 100}%, rgb(from var(--color-fill-gray) r g b / 0.2) ${
          (isMuted ? 0 : volume) * 100
        }%, rgb(from var(--color-fill-gray) r g b / 0.2) 100%)`,
      }}
      {...props}
    />
  );
}
